<!--page starts-->
<section class="page-wrapper">
    <div class="news-hero-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
           <div class="news-hero-detail">
           	   <div class="news-arrow">
                   <a href="javascript:void(0)"><img src="assets/images/down-arrow.svg"></a>  
               </div>
           </div>
        </div>
    </div>
    <div class="news-bottom-section cf">
       <div class="container">
           <div class="news-bottom-detail cf" *ngIf="podcastList?.length > 0">
               <div class="titel-box">
	      	 		<h2 class="titel-name">Podcast</h2>
	      	 	</div>
	      	 	<div class="video-bottom-section">
                    <div class="latest-new-detail cf">
		      	 		<div class="latest-video-box" *ngFor="let podcast of podcastList">
		      	 			<div class="latest-video-box-top">
			      	 			
			      	 				<div class="latest-new-image">
										<img [src]="podcast?.image">
			      	 				</div>
									<div class="latest-new-image-hover">
										<img [src]="podcast?.image">
									</div> 
			      	 				<div class="video-overlay">
										<ngx-audio-player [playlist]="podcast?.msaapPlaylist" [displayTitle]="msaapDisplayTitle" [autoPlay]="false"
										muted="muted" [displayPlaylist]="msaapDisplayPlayList" [pageSizeOptions]="msaapPageSizeOptions" 
										[displayArtist]="msaapDisplayArtist" [displayDuration]="msaapDisplayDuration"
										[expanded]="true" [displayVolumeControls]="msaapDisplayVolumeControls" [displayRepeatControls]="msaapDisplayRepeatControls" 
										[disablePositionSlider]="msaapDisablePositionSlider"></ngx-audio-player>
	                                    
			      	 				</div>
				      	 		
				      	 	</div>
		      	 		</div>
		      	 	</div>
		      	 	<div class="news-tab-btn" *ngIf="!podcastList_last_page">
                        <a (click)="getMorePodcast()">View More</a>
		      	 	</div>
	      	 	</div>
           </div> 
       </div>
    </div>
</section><!-- page ends-->